export default "__VITE_ASSET__BtxXlM4x__"